import { useDownloads } from '@views/pages/Downloads/hooks';
import { Box, Button, Typography, Tab } from '@mui/material';
import { t } from 'i18next';
import {
  CarePlanDownloads,
  ReportsDownload,
} from '@views/pages/Downloads/components';
import { ConfirmationModal } from '@components';
import { TabContext, TabList, TabPanel } from '@mui/lab';

export const Downloads = () => {
  const {
    handleDownloadAll,
    handleDelete,
    totalReportsCount,
    isDeleting,
    isMultipleDownloads,
    isDeleteModalOpen,
    handleOpenDeleteModal,
    handleCloseDeleteModal,
    handleChangeTabIndex,
    tabIndex,
    isDeleteButtonDisabled,
    isDownloadButtonDisabled,
    setIsDeleteButtonDisabled,
    currentDownloadItem,
    setReportSelectedItems,
    totalCarePlanCount,
    setCarePlanSelectedItems,
    carePlanSelectedItems,
    reportSelectedItems,
  } = useDownloads();

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant='h4' sx={{ mb: 2, mt: 2 }}>
          {t('downloads.title')}
        </Typography>

        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          <Button
            sx={{
              fontWeight: 'regular',
              fontSize: '1rem',
              color: 'white',
              padding: '8px 22px',
            }}
            onClick={handleDownloadAll}
            disabled={isDownloadButtonDisabled}
            color='secondary'
            variant='contained'
          >
            {t('downloads.download')}
          </Button>
          <Button
            variant='outlined'
            color='primary'
            sx={{
              fontWeight: 'regular',
              fontSize: '1rem',
              padding: '8px 22px',
            }}
            disabled={isDeleteButtonDisabled}
            onClick={handleOpenDeleteModal}
          >
            {t('general.delete')}
          </Button>
        </Box>
      </Box>

      <TabContext value={tabIndex}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={handleChangeTabIndex}>
            <Tab
              label={t('downloads.reports', {
                number: totalReportsCount > 0 ? ` (${totalReportsCount})` : '',
              })}
              value='reports'
            />
            <Tab
              label={t('downloads.carePlans', {
                number: totalReportsCount > 0 ? ` (${totalCarePlanCount})` : '',
              })}
              value='care_plan'
            />
          </TabList>
        </Box>
        <TabPanel value='reports'>
          <ReportsDownload
            handleCloseDeleteModal={handleCloseDeleteModal}
            setIsDeleteButtonDisabled={setIsDeleteButtonDisabled}
            currentDownloadItem={currentDownloadItem}
            setSelectedItems={setReportSelectedItems}
            isMultipleDownloads={isMultipleDownloads}
            selectedItems={reportSelectedItems}
          />
        </TabPanel>
        <TabPanel value='care_plan'>
          <CarePlanDownloads
            handleCloseDeleteModal={handleCloseDeleteModal}
            setIsDeleteButtonDisabled={setIsDeleteButtonDisabled}
            currentDownloadItem={currentDownloadItem}
            setSelectedItems={setCarePlanSelectedItems}
            isMultipleDownloads={isMultipleDownloads}
            selectedItems={carePlanSelectedItems}
          />
        </TabPanel>
      </TabContext>

      <ConfirmationModal
        title={t('downloads.deleteModal.title')}
        message={t('downloads.deleteModal.message')}
        onConfirm={handleDelete}
        onClose={handleCloseDeleteModal}
        isOpen={isDeleteModalOpen}
        isLoading={isDeleting}
        confirmText={t('general.delete')}
      />
    </>
  );
};
